import { render, staticRenderFns } from "./PayoutsSection.vue?vue&type=template&id=dcbed946&"
import script from "./PayoutsSection.vue?vue&type=script&lang=js&"
export * from "./PayoutsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports